<fcom-modal
  [open]="modalOpen"
  [title]="'kidsInBusinessNotification.modalTitle' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [fullHeight]="true"
  (close)="closeModal()"
  data-testid="air-lounge-modal"
>
  <div class="nordic-blue-900-text text-icon-primary pr-large-x pr-small-y">
    <cms-rich-text
      *ngFor="let article of content$ | async; let isLast = last"
      data-testid="first-content"
      [content$]="article | finToObservable"
      [headerStyles]="headerStyles"
      [extraClasses]="isLast ? undefined : 'mr-large-b'"
    />
    <div class="mr-large-t">
      <fcom-checkbox-input
        [parentForm]="checkboxForm"
        [controlName]="'checked'"
        data-testid="kids-in-business-notification-checkbox"
      >
        <span class="font-body-1 medium-type font-label-medium">
          {{ 'kidsInBusinessNotification.checkboxLabel' | finLocalization }}
        </span>
      </fcom-checkbox-input>
    </div>
    <div #errorMessage>
      <div
        *ngIf="showErrorMessage"
        class="pr-small-t font-body-1 error-900-text signal-error-notification-border-icon-text font-body-medium"
        data-testid="error-message"
      >
        {{ 'kidsInBusinessNotification.errorMessage' | finLocalization }}
      </div>
    </div>
  </div>
  <div buttons>
    <fcom-button
      [text]="cancelButtonLabel()"
      [theme]="cancelButtonTheme()"
      [mode]="ButtonMode.FILL_MOBILE"
      [aria]="{ label: cancelButtonLabel(), role: 'button' }"
      (clickBtn)="emitCancel()"
      class="mr-xsmall-t mr-xxsmall-b mr-xxsmall-x"
      data-testid="cancel-button"
    />
    <fcom-button
      [text]="continueButtonLabel()"
      [theme]="continueButtonTheme()"
      [mode]="ButtonMode.FILL_MOBILE"
      [aria]="{ label: continueButtonLabel(), role: 'button' }"
      (clickBtn)="emitContinue()"
      class="mr-xsmall-t mr-xxsmall-b mr-xxsmall-x"
      data-testid="continue-button"
    />
  </div>
</fcom-modal>
